import Rollbar from 'rollbar';

const projectToken = 'f4a2f216202b4c66965b7e365bc13a57';
const isProduction = process.env.NODE_ENV === 'production';

const ignoreMessages = () => {
  const messages = [
    'Network Error',
    'Request failed with status code 404',
    'timeout of 0ms exceeded'
  ];
  return messages;
};

const logError = (error, info) => {
  if (isProduction && !ignoreMessages().includes(error.message)) {
    // eslint-disable-next-line
    console.log(
      'Something went wrong. A report has been sent to the Administrator. Please try to reload the page.'
    );
    const rollbar = new Rollbar({
      accessToken: projectToken,
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        environment: process.env.NODE_ENV || 'development'
      }
    });
    rollbar.error(error);
  } else {
    console.log(error); // eslint-disable-line
    console.log(info); // eslint-disable-line
  }
};

export default logError;
